import {
  Component, OnInit, Input, ViewChild, TemplateRef, OnChanges,
} from '@angular/core';
import {
  ModalService, AnalyticsService,
} from '@ui-kit';
import { get } from 'lodash-es';
// eslint-disable-next-line import/no-unresolved
import { P } from '@ui-kit/ui-kit';
import { Router } from '@angular/router';
import { NotificationService, UserService } from '../../service';
import { LeanListing } from '../../../public/homes/homes.helpers';
import { AppService } from '../../../app.service';
import { LeanFavourite } from '../../../public/favourites/shortlist.helpers';

@Component({
  selector: 'app-home-thumbnail',
  templateUrl: './home-thumbnail.component.html',
  styleUrls: ['./home-thumbnail.component.scss'],
})
export class HomeThumbnailComponent implements OnChanges {
  @ViewChild('signUpAdTemplate') signUpAdTemplate: TemplateRef<unknown>;

  @Input() data: LeanListing;

  @Input() isRecommended: boolean;

  toggle: Dictionary<boolean> = {};

  isFavourite: boolean = false;

  constructor(
    private app: AppService,
    private user: UserService,
    private modal: ModalService,
    private analytics: AnalyticsService,
    private router: Router,
    private notifications: NotificationService,
  ) {
  }

  ngOnChanges(): void {
    const shortlist = get(this.user, 'current.application.shortlist', []);
    const favouriteListingIds = shortlist.map((shortlist) => shortlist?.listing.id);
    this.isFavourite = favouriteListingIds.includes(this.data.id);
  }

  onFavourite(): void {
    if (this.user.signedIn) {
      this.toggle.working = true;
      this.user
        .favourite({
          listing: this.data.id,
          url: this.data.source_data.details_url,
        })
        .toPromise()
        .then(this.onFavouriteSuccess.bind(this))
        .catch((error) => this.modal.open(error.message))
        .finally(() => {
          this.toggle.working = false;
          this.app.event.emit({ type: 'trigger-update' });
        });
    } else {
      this.modal
        .open(this.signUpAdTemplate, { nav: false, maxWidth: 'm' });
    }
  }

  private onFavouriteSuccess(enquiry: LeanFavourite): void {
    this.data.favourite = true;

    this.notifications.notifyEnquiryStatus(enquiry);

    this.analytics.eventTrack({
      data: {
        event: 'http',
        action: 'add_home_success',
        label: 'home_thumbnail',
        properties: {
          value: '1',
          category: 'internal',
          route: this.router.url,
        },
      },
    });

    if (this.user.current?.application?.shortlist?.length === 1) {
      this.app.event.emit({ type: 'trigger-rightmove', data: 'enquiry' });
    }

    this.app.event.emit({ type: 'trigger-update' });
  }
}
